import { render } from "./LossRecords.vue?vue&type=template&id=5675a786&scoped=true"
import script from "./LossRecords.vue?vue&type=script&lang=js"
export * from "./LossRecords.vue?vue&type=script&lang=js"

import "./LossRecords.vue?vue&type=style&index=0&id=5675a786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5675a786"]])

export default __exports__